<script setup lang="ts">
import { computed } from 'vue';
import { useResourceEventsByDateQuery } from '/@entities/resourceEvent/api/useResourceEventsByDateQuery';
import { ResourceEvent } from '/@types/resources';
import { date } from '/@utilities/intl';

const props = defineProps<{
  event: ResourceEvent;
}>();

const { data: rawEvents } = useResourceEventsByDateQuery(
  computed(() => props.event.fromDate),
  computed(() => props.event.toDate),
);

const activeEvents = computed(() => {
  if (!rawEvents.value) return [];
  return rawEvents.value
    .filter((e) => e.projectId === props.event.projectId)
    .map((e) => ({ ...e, isSelectedDate: e.guid === props.event.guid }))
    .sort((a, b) => a.fromDate.getTime() - b.fromDate.getTime());
});
</script>

<template>
  <div class="card user-list" v-if="activeEvents.length > 1">
    <header class="user-list-header">
      <h2 class="title-sm">Ressurs på samme avtale</h2>
    </header>

    <ul>
      <li
        v-for="event in activeEvents"
        :key="event.guid"
        :class="{ '--bold': event.isSelectedDate }"
      >
        <div>{{ event.userName }}</div>
        <div>
          {{
            event.fromDate.getDate() === event.toDate.getDate()
              ? date(event.fromDate, { short: true })
              : [date(event.fromDate, { short: true }), date(event.toDate, { short: true })].join(
                  ' - ',
                )
          }}
        </div>
      </li>
    </ul>
  </div>
</template>

<style scoped>
ul {
  font-size: 0.8rem;
  max-height: 300px;
  overflow: auto;
}

li {
  display: flex;
  justify-content: space-between;
  padding: var(--gap-sm);
  font-weight: 500;
  opacity: 1;
}

.user-list-header {
  display: flex;
  justify-content: space-between;
}

.user-list {
  display: flex;
  flex-direction: column;
  gap: var(--gap-md);
}
</style>
